import React, { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import queryString from 'query-string';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, alreadyLoggedIn } = useAuth();
  const [nextLocation, setNextLocation] = useState('');
  const location = useLocation();

  useEffect(() => {
    const parse = queryString.parse(location.search);
    if (parse && parse.next) {
      let next = parse.next.split('.').join('/');
      setNextLocation(next);
    }
  }, []);

  if (isAuthenticated) {
    // if (alreadyLoggedIn) {
    //   return (
    //     <Redirect
    //       to={{ pathname: '/app/dashboard', state: { from: location } }}
    //     />
    //   );
    // }
    if (nextLocation !== '') {
      return <Redirect to={nextLocation} />;
    }

    return <Redirect to="/app/dashboard" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
